<div class="job-sync-status-drawer"
     data-testid="sync-status-drawer-container">
  <div class="badge-container"
       data-testid="sync-status-badge-container">
    <p-tag [severity]="getSyncStatusInfo().badgeSeverity"
           class="status-tag"
           [rounded]="true"
           data-testid="sync-status-badge">
      <i [class]="getSyncStatusInfo().badgeIconClass"></i>
      {{ getSyncStatusInfo().badgeText }}
    </p-tag>
  </div>
  @if (getSyncStatusState() !== jobSyncStatusStateEnum.Overdue)
  {
    <p-divider />
    <div class="upload-progress-container"
         data-testid="sync-status-progress-container">
      <div class="upload-progress-numbers">
        <table data-testid="sync-status-progress-table">
          @for(item of groupedMetadata(); track item.label)
          {
            <tr>
              <td class="progress-label">{{ item.label }}: </td>
              <td class="progress-number-current">{{ item.value.current }}</td>
              <td class="progress-number-of">of</td>
              <td class="progress-number-total">{{ item.value.total }}</td>
            </tr>
          }
        </table>
      </div>
      <div class="upload-progress-dial"
           data-testid="sync-status-progress-dial">
        @if(progressGuageValues().showCheck) {
          <i class="pi pi-check complete-check"></i>
        }
        <svg [attr.width]="svgSize"
             [attr.height]="svgSize"
             version="1.1"
             xmlns="http://www.w3.org/2000/svg"
             style="transform:rotate(-90deg)">
          <circle r="30"
                  cx="40"
                  cy="40"
                  fill="transparent"
                  stroke="#f3f4f6"
                  stroke-width="9"></circle>
          <circle r="30"
                  cx="40"
                  cy="40"
                  [attr.stroke]="progressGuageValues().strokeColor"
                  stroke-width="9"
                  stroke-linecap="butt"
                  [attr.stroke-dashoffset]="progressGuageValues().percentCompleteSvgDashValue"
                  [attr.fill]="progressGuageValues().fillColor"
                  stroke-dasharray="188.4px"></circle>
          <text [attr.x]="progressGuageValues().textXPosition"
                y="42px"
                [attr.fill]="progressGuageValues().fontColor"
                font-size="16px"
                [attr.font-weight]="progressGuageValues().fontWeight"
                style="transform:rotate(90deg) translate(0px, -76px)">{{progressGuageValues().percentComplete}}%</text>
        </svg>

      </div>
    </div>
    <p-divider />
  }
  @if(getSyncStatusState() === jobSyncStatusStateEnum.CompletePending) {
    <p-tag severity="warn"
           class="status-tag"
           [rounded]="true"
           data-testid="sync-status-badge-pending">
      <i class="pi pi-sync"></i>
      Pending Items
    </p-tag>
  }
  <div class="upload-message-container"
       data-testid="sync-status-message-container">
    <div class="upload-progress-message"
         [innerHTML]="getMessageWithJobActionName(getMessageWithCount(getSyncStatusInfo().message1, getPendingCount()), jobActionName)"></div>
    <div class="upload-progress-message"
         [innerHTML]="getSyncStatusInfo().message2"></div>
  </div>
  @if(getSyncStatusInfo().actionButtonText)
  {
    <p-button (onClick)="onSyncStatusAction()"
              styleClass="bqa-primary-btn p-fullwidth-button"
              severity="primary"
              data-testid="sync-status-btn-action">
      {{ getMessageWithJobActionName(getSyncStatusInfo().actionButtonText, jobActionName) }}
    </p-button>
  }
</div>